<div class="clr-col">
  <!--
    the title is also a key (e.g. of the saved datagrid state), so it is only
    put in the site's terminology here, where it is shown
  -->
  <h2>{{ title | titlecase | term }}</h2>
</div>
<div class="clr-col-6 actions">
  <ng-content></ng-content>
  <button
    *ngFor="let action of actions"
    (click)="clicks.emit(action.text)"
    class="btn btn-{{ action.class }}-outline"
  >
    <!-- the text itself is what (clicks) emits: reworded for display only -->
    {{ action.text | term }}
  </button>
</div>
